require("./bootstrap");

import Vue from "vue";

// - - - - -   plugins   - - - - - - - - - -
import VueMask from "v-mask";
Vue.use(VueMask);

import VueMeta from "vue-meta";
Vue.use(VueMeta);

import VueLazyload from "vue-lazyload";
Vue.use(VueLazyload);

import OtpInput from "@bachdgvn/vue-otp-input";
Vue.component("v-otp-input", OtpInput);

import Notifications from "vue-notification";
Vue.use(Notifications);

// - - - - - -   mixins - - - - - - - - - -
Vue.mixin({
    methods: {
        callYandexMapAndAddPlacemark(latitudeLongitude, placemarkName) {
            ymaps.ready(init);

            function init() {
                const myMap = new ymaps.Map("yandex__map", {
                    center: latitudeLongitude,
                    zoom: 16
                });

                const myPlacemark = new ymaps.Placemark(
                    latitudeLongitude,
                    {
                        balloonContent: placemarkName,
                        iconContent: placemarkName
                    },

                    { preset: "islands#blueStretchyIcon" }
                );
                myMap.geoObjects.add(myPlacemark);
            }
        },

        callYandexMapOnDelivery() {
            ymaps.ready(initSecond);
            function initSecond() {
                const myMapSecond = new ymaps.Map("yandex__map__delivery", {
                    center: [41.326585, 69.255716],
                    zoom: 16
                });
                const geolocation = ymaps.geolocation;
                // Сравним положение, вычисленное по ip пользователя и
                // положение, вычисленное средствами браузера.
                let userCoords;
                geolocation
                    .get({
                        provider: "browser",
                        mapStateAutoApply: true
                    })
                    .then(function(result) {
                        // myMapSecond.geoObjects.add(result.geoObjects);
                        const myPlacemark = createPlacemark(
                            result.geoObjects.position
                        );
                        myPlacemark.properties.set("iconCaption", "Геолокация");
                        myMapSecond.geoObjects.add(myPlacemark);
                        getAddressSecond(result.geoObjects.position);
                    });
                // // Определяем адрес по координатам (обратное геокодирование).
                function getAddressSecond(coords) {
                    ymaps.geocode(coords).then(function(res) {
                        var firstGeoObject = res.geoObjects.get(0);
                        const geoCode = [
                            firstGeoObject.getAddressLine(),
                            coords
                        ];
                        window.localStorage.setItem(
                            "geoDataUser",
                            JSON.stringify(geoCode)
                        );
                    });
                }
                var myPlacemark;
                // Слушаем клик на карте.
                myMapSecond.events.add("click", function(e) {
                    var coords = e.get("coords");
                    // Если метка уже создана – просто передвигаем ее.
                    if (myPlacemark) {
                        myPlacemark.geometry.setCoordinates(coords);
                    }
                    // Если нет – создаем.
                    else {
                        myPlacemark = createPlacemark(coords);
                        myMapSecond.geoObjects.add(myPlacemark);
                        // Слушаем событие окончания перетаскивания на метке.
                        myPlacemark.events.add("dragend", function() {
                            getAddress(myPlacemark.geometry.getCoordinates());
                        });
                    }
                    getAddress(coords);
                });
                // Создание метки.

                function createPlacemark(coords) {
                    return new ymaps.Placemark(
                        coords,
                        {
                            iconCaption: "поиск..."
                        },
                        {
                            preset: "islands#violetDotIconWithCaption",
                            draggable: true
                        }
                    );
                }

                // Определяем адрес по координатам (обратное геокодирование).
                function getAddress(coords) {
                    myPlacemark.properties.set("iconCaption", "поиск...");
                    ymaps.geocode(coords).then(function(res) {
                        var firstGeoObject = res.geoObjects.get(0);
                        myPlacemark.properties.set({
                            // Формируем строку с данными об объекте.
                            iconCaption: [
                                // Название населенного пункта или вышестоящее административно-территориальное образование.
                                firstGeoObject.getLocalities().length
                                    ? firstGeoObject.getLocalities()
                                    : firstGeoObject.getAdministrativeAreas(),
                                // Получаем путь до топонима, если метод вернул null, запрашиваем наименование здания.
                                firstGeoObject.getThoroughfare() ||
                                    firstGeoObject.getPremise()
                            ]
                                .filter(Boolean)
                                .join(", "),
                            // В качестве контента балуна задаем строку с адресом объекта.
                            balloonContent: firstGeoObject.getAddressLine()
                        });
                        const geoCode = [
                            firstGeoObject.getAddressLine(),
                            coords
                        ];
                        window.localStorage.setItem(
                            "geoData",
                            JSON.stringify(geoCode)
                        );
                    });
                }
            }
        },

        callYandexMapOnPickupPlace(warehouseList) {
            ymaps.ready(initThird);
            function initThird() {
                const myMap = new ymaps.Map("yandex__map__pickup", {
                    center: [41.326585, 69.255716],
                    zoom: 16
                });

                warehouseList.forEach(warehouse => {
                    const myPlacemark = new ymaps.Placemark(
                        [Number(warehouse.lat), Number(warehouse.lot)],
                        {
                            balloonContent: `Вы выбрали ${warehouse.address
                                .split(" ")[0]
                                .replace(/\./g, "")}`,
                            iconContent: warehouse.address.split(" ")[0]
                        },
                        { preset: "islands#blueStretchyIcon" }
                    );

                    myPlacemark.events.add(["balloonopen"], function(e) {
                        myMap.setCenter([
                            Number(warehouse.lat),
                            Number(warehouse.lot)
                        ]);
                        myMap.setZoom(16);
                        document.getElementById("pickupPlace").value =
                            warehouse.id;
                    });
                    myMap.geoObjects.add(myPlacemark);
                });

                document.getElementById("pickupPlace").onchange = function(e) {
                    console.log("asdas log", e);
                    const activeWarehose = warehouseList.find(
                        elem => elem.id === Number(e.target.value)
                    );

                    myMap.setCenter([
                        Number(activeWarehose.lat),
                        Number(activeWarehose.lot)
                    ]);
                    myMap.setZoom(16);
                };
            }
        },

        callYandexMapOnApplication() {
            ymaps.ready(initSecond);
            function initSecond() {
                const myMapSecond = new ymaps.Map("yandex__map__application", {
                    center: [41.326585, 69.255716],
                    zoom: 16
                });
                const geolocation = ymaps.geolocation;
                // Сравним положение, вычисленное по ip пользователя и
                // положение, вычисленное средствами браузера.
                let userCoords;
                geolocation
                    .get({
                        provider: "browser",
                        mapStateAutoApply: true
                    })
                    .then(function(result) {
                        myMapSecond.setCenter(result.geoObjects.position);
                    });

                var myPlacemark;
                // Слушаем клик на карте.
                myMapSecond.events.add("click", function(e) {
                    var coords = e.get("coords");
                    // Если метка уже создана – просто передвигаем ее.
                    if (myPlacemark) {
                        myPlacemark.geometry.setCoordinates(coords);
                    }
                    // Если нет – создаем.
                    else {
                        myPlacemark = createPlacemark(coords);
                        myMapSecond.geoObjects.add(myPlacemark);
                        // Слушаем событие окончания перетаскивания на метке.
                        myPlacemark.events.add("dragend", function() {
                            getAddress(myPlacemark.geometry.getCoordinates());
                        });
                    }
                    getAddress(coords);
                });
                // Создание метки.

                function createPlacemark(coords) {
                    return new ymaps.Placemark(
                        coords,
                        {
                            iconCaption: "поиск..."
                        },
                        {
                            preset: "islands#violetDotIconWithCaption",
                            draggable: true
                        }
                    );
                }

                // Определяем адрес по координатам (обратное геокодирование).
                function getAddress(coords) {
                    myPlacemark.properties.set("iconCaption", "поиск...");
                    ymaps.geocode(coords).then(function(res) {
                        var firstGeoObject = res.geoObjects.get(0);
                        myPlacemark.properties.set({
                            // Формируем строку с данными об объекте.
                            iconCaption: [
                                // Название населенного пункта или вышестоящее административно-территориальное образование.
                                firstGeoObject.getLocalities().length
                                    ? firstGeoObject.getLocalities()
                                    : firstGeoObject.getAdministrativeAreas(),
                                // Получаем путь до топонима, если метод вернул null, запрашиваем наименование здания.
                                firstGeoObject.getThoroughfare() ||
                                    firstGeoObject.getPremise()
                            ]
                                .filter(Boolean)
                                .join(", ")
                        });
                        const geoCode = [
                            firstGeoObject.getAddressLine(),
                            coords
                        ];
                        window.localStorage.setItem(
                            "geoApplication",
                            JSON.stringify(geoCode)
                        );
                    });
                }
            }
        }
    }
});

// - - - - - -    main app - - - - - - - - -
import store from "./store/index";
import router from "./router/index";

const app = new Vue({
    el: "#app",
    store,
    router
});
